<iframe [src]="swaggerURL" [style]="'width: 100%; border: none'" [height]="windowHeight - 56"></iframe>
